import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionDto } from '../../../models/session.model';
import { PasswordLinkDto } from './models/password-link.dto';

// Both calls are anonymous — the token is the credential — and carry it in the body, never the URL
@Injectable({ providedIn: 'root' })
export class SetPasswordProvider {
  constructor(private http: HttpClient) {}

  checkPasswordLink(token: string): Observable<PasswordLinkDto> {
    const url = `/api/auth/password-link/check`;
    return this.http.post<PasswordLinkDto>(url, { token });
  }

  // Answers like sign-in does: the new session, cookie included
  setPassword(token: string, password: string): Observable<SessionDto> {
    const url = `/api/auth/set-password`;
    return this.http.post<SessionDto>(url, { token, password });
  }
}
